/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './page.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../shared/customer-navbar/customer-navbar.component.ngfactory';
import * as i3 from '../../../app/shared/customer-navbar/customer-navbar.component';
import * as i4 from '../../../app/auth/current-user';
import * as i5 from '../../../app/shared/settings.service';
import * as i6 from '../shared/customer-footer/customer-footer.component.ngfactory';
import * as i7 from '../../../app/shared/customer-footer/customer-footer.component';
import * as i8 from '../../../app/pages/page.component';
import * as i9 from '../../../app/admin/pages/pages.service';
import * as i10 from '@angular/router';
const styles_PageComponent:any[] = [i0.styles];
export const RenderType_PageComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_PageComponent,data:{}});
export function View_PageComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'customer-navbar',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_CustomerNavbarComponent_0,
      i2.RenderType_CustomerNavbarComponent)),i1.ɵdid(49152,(null as any),0,i3.CustomerNavbarComponent,
      [i4.CurrentUser,i5.SettingsService],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'div',[['class','page-body article-body']],
      [[8,'innerHTML',1]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'customer-footer',[['id','customer-footer']],(null as any),(null as any),
          (null as any),i6.View_CustomerFooterComponent_0,i6.RenderType_CustomerFooterComponent)),
      i1.ɵdid(49152,(null as any),0,i7.CustomerFooterComponent,[i5.SettingsService],
          (null as any),(null as any))],(null as any),(_ck,_v) => {
    var _co:i8.PageComponent = _v.component;
    const currVal_0:any = _co.page.body;
    _ck(_v,3,0,currVal_0);
  });
}
export function View_PageComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'page',([] as any[]),
      (null as any),(null as any),(null as any),View_PageComponent_0,RenderType_PageComponent)),
      i1.ɵdid(114688,(null as any),0,i8.PageComponent,[i9.Pages,i10.ActivatedRoute,
          i10.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PageComponentNgFactory:i1.ComponentFactory<i8.PageComponent> = i1.ɵccf('page',
    i8.PageComponent,View_PageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvcGFnZXMvcGFnZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2UvYXBwcy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9wYWdlcy9wYWdlLmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvcGFnZXMvcGFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvcGFnZXMvcGFnZS5jb21wb25lbnQudHMuUGFnZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxjdXN0b21lci1uYXZiYXI+PC9jdXN0b21lci1uYXZiYXI+XHJcblxyXG48ZGl2IGNsYXNzPVwicGFnZS1ib2R5IGFydGljbGUtYm9keVwiIFtpbm5lckhUTUxdPVwicGFnZS5ib2R5XCI+PC9kaXY+XHJcblxyXG48Y3VzdG9tZXItZm9vdGVyPjwvY3VzdG9tZXItZm9vdGVyPiIsIjxwYWdlPjwvcGFnZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBOzJDQUFBLFVBQUE7TUFBQSxpRUFBbUM7TUFBQSxXQUVuQztNQUFBO01BQWtFLHlDQUVsRTtVQUFBO1VBQUE7YUFBQTtVQUFBOztJQUZvQztJQUFwQyxXQUFvQyxTQUFwQzs7OztvQkNGQTtNQUFBO2FBQUE7b0JBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/pages/page.component.ngfactory.ts